module.exports = __webpack_public_path__ + "04_short_gray.a065d7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_short_gray.png
// module id = UZAD
// module chunks = 0